<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Archivo"   />

    <Repository />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Repository from "@/components/Pages/Admin/Repository/index.vue";

export default defineComponent({
  name: "PlaysPage",
  components: {
    PageTitle,
    Repository,
  },
});
</script>
